'use client';
import { Terminal, X } from 'lucide-react';

export default function ConsoleOverlay({ logs, isRunning, onBlur }: { logs: string[], isRunning: boolean, onBlur: () => void }) {
  if (!isRunning && logs.length === 0) return null;

  return (
    <div className="fixed bottom-8 right-8 w-96 bg-black border border-amber-500/30 rounded-lg shadow-2xl animate-in slide-in-from-bottom-4 duration-300 z-50">
      <div className="flex justify-between items-center p-3 border-b border-white/10 bg-white/5">
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 rounded-full ${isRunning ? 'bg-amber-500 animate-ping' : 'bg-green-500'}`} />
          <span className="text-[10px] font-black uppercase text-slate-300 tracking-widest">Pipeline Console</span>
        </div>
        {!isRunning && (
          <button onClick={onBlur} className="text-slate-500 hover:text-white transition-colors">
            <X size={14} />
          </button>
        )}
      </div>
      <div className="p-4 font-mono text-[11px] space-y-2 max-h-60 overflow-y-auto scrollbar-hide">
        {logs.map((log, i) => (
          <div key={i} className="flex gap-2 text-slate-400">
            <span className="text-slate-600 shrink-0">[{new Date().toLocaleTimeString([], {hour:'2-digit', minute:'2-digit', second:'2-digit'})}]</span>
            <span className={i === logs.length - 1 ? "text-amber-400" : ""}>{log}</span>
          </div>
        ))}
        {isRunning && <div className="text-amber-500 animate-pulse">_</div>}
      </div>
    </div>
  );
}